import { useFormikContext } from 'formik';
import React from 'react';

import AutocompleteField from '@components/Form/AutocompleteField';
import DropdownField from '@components/Form/DropdownField';
import { useEntitiesCreate } from '@hooks';
import { autocompleteEntities } from '@utils/backend-api/entities';
import {
  ENTITY_TYPE_JOB_LEVEL,
  ENTITY_WORD_TYPE_COMMON,
  JOB_LEVEL_OPTIONS,
  PROFILE_FIELD_OTHER_VALUE,
} from '@utils/backend-api/profileSettings';

import { StepProfileFormProps } from '../StepProfile';

const JobLevelFields = () => {
  const { values } = useFormikContext<StepProfileFormProps>();
  const { mutateAsync: createEntityAsync } = useEntitiesCreate();

  return (
    <>
      <DropdownField
        name="jobLevel"
        options={JOB_LEVEL_OPTIONS}
        label="Job Level&#42;"
        placeholder="Select"
        isClearable={false}
      />
      {values.jobLevel.value === PROFILE_FIELD_OTHER_VALUE && (
        <div className="mt-4">
          <AutocompleteField
            name="customJobLevel"
            fetchMethod={(value) =>
              autocompleteEntities({
                fragment: value,
                entity_type: ENTITY_TYPE_JOB_LEVEL,
              })
            }
            createMethod={(value) =>
              createEntityAsync({
                name: value,
                entity_type: ENTITY_TYPE_JOB_LEVEL,
                word_type: ENTITY_WORD_TYPE_COMMON,
              })
            }
          />
        </div>
      )}
    </>
  );
};

export default JobLevelFields;
